import { RemoteServiceChartConfig } from '@vi-iot/client';

export const chartsConfigMock: RemoteServiceChartConfig[] = (<unknown>[
  {
    figure: 'rsf_001',
    title: 'title_availability_and_outside_temperature',
    features: ['adf_1', 'adf_2', 'adf_3', 'adf_4', 'adf_144', 'adf_145', 'adf_147'],
    scale: {},
    type: 'line',
    description: 'desc_availability_and_outside_temperature',
  },
  {
    figure: 'rsf_002',
    title: 'title_pressure_sensor',
    features: ['adf_24'],
    scale: { min: 0, max: 3 },
    type: 'line',
    description: 'desc_pressure_sensor',
  },
  {
    figure: 'rsf_003',
    title: 'title_starts_and_runtime_burner_compressor',
    features: ['adf_8', 'adf_9', 'adf_10', 'adf_79', 'adf_13', 'adf_14', 'adf_15'],
    scale: {},
    type: 'line',
    description: 'desc_starts_and_runtime_burner_compressor',
  },
  {
    figure: 'rsf_004',
    title: 'title_boiler_activity',
    features: ['adf_37', 'adf_25', 'adf_32'],
    scale: {},
    type: 'line',
    description: 'desc_boiler_activity',
  },
  {
    figure: 'rsf_005',
    title: 'title_ignition_time_distribution',
    features: [
      'adf_248',
      'adf_249',
      'adf_250',
      'adf_251',
      'adf_252',
      'adf_253',
      'adf_254',
      'adf_255',
      'adf_256',
    ],
    scale: {},
    type: 'pie',
    description: 'desc_ignition_time_distribution',
  },
  {
    figure: 'rsf_006',
    title: 'title_ignition_time_long_vs_short',
    features: ['adf_267', 'adf_268'],
    scale: {},
    type: 'pie',
    description: 'desc_ignition_time_long_vs_short',
  },
  {
    figure: 'rsf_007',
    title: 'title_flue_temperature_heating',
    features: ['adf_49', 'adf_55'],
    scale: { min: 0, max: 115 },
    type: 'line',
    description: 'desc_flue_temperature_heating',
  },
  {
    figure: 'rsf_008',
    title: 'title_flue_temperature_dhw',
    features: ['adf_58', 'adf_64'],
    scale: { min: 0, max: 115 },
    type: 'line',
    description: 'desc_flue_temperature_dhw',
  },
  {
    figure: 'rsf_009',
    title: 'title_dhw_heat_exchanger',
    features: ['adf_26', 'adf_30', 'adf_31'],
    scale: {},
    type: 'line',
    description: 'desc_dhw_heat_exchanger',
  },
  {
    figure: 'rsf_010',
    title: 'title_meter_readings',
    features: ['adf_17', 'adf_18', 'adf_19', 'adf_6', 'adf_7', 'adf_11', 'adf_12'],
    scale: {},
    type: 'line',
    description: 'desc_meter_readings',
  },
  {
    figure: 'rsf_011',
    title: 'title_starts_and_runtime_fuel_cell',
    features: ['adf_20', 'adf_21'],
    scale: {},
    type: 'line',
    description: 'desc_starts_and_runtime_fuel_cell',
  },
  {
    figure: 'rsf_012',
    title: 'title_output_fuel_cell',
    features: ['adf_16', 'adf_22', 'adf_23'],
    scale: {},
    type: 'line',
    description: 'desc_output_fuel_cell',
  },
  {
    figure: 'rsf_013',
    title: 'title_dhw_storage_top_vs_bottom',
    features: ['adf_118', 'adf_114', 'adf_86', 'adf_90'],
    scale: {},
    type: 'line',
    description: 'desc_dhw_storage_top_vs_bottom',
  },
  {
    figure: 'rsf_014',
    title: 'title_maximum_target_supply',
    features: ['adf_128', 'adf_132', 'adf_136', 'adf_140'],
    scale: {},
    type: 'line',
    description: 'desc_maximum_target_supply',
  },
  {
    figure: 'rsf_015',
    title: 'title_solar_thermal_function_check',
    features: ['adf_165', 'adf_166', 'adf_167', 'adf_168', 'adf_169', 'adf_170', 'adf_171'],
    scale: {},
    type: 'line',
    description: 'desc_solar_thermal_function_check',
  },
  {
    figure: 'rsf_016',
    title: 'title_solar_thermal_sensor_check',
    features: ['adf_172', 'adf_173', 'adf_177', 'adf_178'],
    scale: {},
    type: 'line',
    description: 'desc_solar_thermal_sensor_check',
  },
  {
    figure: 'rsf_017',
    title: 'title_solar_thermal_pump_activity',
    features: ['adf_229', 'adf_231', 'adf_232', 'adf_236', 'adf_237', 'adf_238', 'adf_241'],
    scale: {},
    type: 'line',
    description: 'desc_solar_thermal_pump_activity',
  },
  {
    figure: 'rsf_018',
    title: 'title_solar_thermal_temperatures',
    features: ['adf_233', 'adf_234', 'adf_235', 'adf_239', 'adf_240', 'adf_246'],
    scale: {},
    type: 'line',
    description: 'desc_solar_thermal_temperatures',
  },
  {
    figure: 'rsf_019',
    title: 'title_heating_rod_runtime_by_activity',
    features: ['adf_209', 'adf_213', 'adf_217', 'adf_221'],
    scale: {},
    type: 'line',
    description: 'desc_heating_rod_runtime_by_activity',
  },
  {
    figure: 'rsf_020',
    title: 'title_heating_rod_runtime_by_power_level',
    features: ['adf_210', 'adf_211', 'adf_212'],
    scale: {},
    type: 'line',
    description: 'desc_heating_rod_runtime_by_power_level',
  },
  {
    figure: 'rsf_021',
    title: 'title_heating_rod_consumption_by_activity',
    features: ['adf_225', 'adf_226', 'adf_227', 'adf_228'],
    scale: {},
    type: 'line',
    description: 'desc_heating_rod_consumption_by_activity',
  },
]) as RemoteServiceChartConfig[];

export const chartsDataMock = {
  boiler_id: 7570782903267119,
  point_interval: 86400000,
  point_start: 1612483200000,
  datalength: 10,
  series: [
    {
      feature: 'adf_1',
      unit: 'percentage',
      name: 'online_share',
      data: [null, 100, 100, 99.9, 99.98, 96.07, 99.99, 99.96, 99.99, 100],
    },
    {
      feature: 'adf_10',
      unit: 'starts_per_hour',
      name: 'burner_starts_per_hour',
      data: [null, 1, 2.41, 1.74, 0.08, 0.38, 0.08, 0.17, 0.04, 0.04],
    },
    {
      feature: 'adf_122',
      unit: 'degree_celsius',
      name: 'dhw_temperature_min',
      data: [null, 51.2, 27.6, 51.7, 51.6, 48.6, 33.4, 52.5, 34.4, 29.6],
    },
    {
      feature: 'adf_123',
      unit: 'degree_celsius',
      name: 'dhw_temperature_max',
      data: [null, 59.5, 59.7, 59.9, 59.2, 59.1, 59.2, 58.7, 59, 59.3],
    },
    {
      feature: 'adf_124',
      unit: 'degree_celsius',
      name: 'dhw_temperature_mean',
      data: [null, 55.34, 54.8, 55.97, 55.01, 55.7, 55.79, 55.97, 55.36, 55.69],
    },
    {
      feature: 'adf_125',
      unit: 'degree_celsius',
      name: 'dhw_temperature_iqm',
      data: [null, 55.09, 56.24, 55.87, 54.75, 56.42, 56.07, 55.99, 55.29, 56.31],
    },
    {
      feature: 'adf_126',
      unit: 'kelvin',
      name: 'dhw_temperature_std',
      data: [null, 2.07, 4.46, 2.05, 1.87, 3.1, 2.37, 1.81, 2.24, 3.41],
    },
    {
      feature: 'adf_144',
      unit: 'decibel_milliwatt',
      name: 'wifi_strength_min',
      data: [null, -48, -43, -43, -48, -52, -50, -52, -52, -49],
    },
    {
      feature: 'adf_145',
      unit: 'decibel_milliwatt',
      name: 'wifi_strength_max',
      data: [null, -39, -39, -38, -39, -39, -39, -46, -46, -46],
    },
    {
      feature: 'adf_146',
      unit: 'decibel_milliwatt',
      name: 'wifi_strength_mean',
      data: [null, -41.54, -40.52, -40.54, -40.8, -43.89, -45.13, -47.11, -47.01, -47.13],
    },
    {
      feature: 'adf_147',
      unit: 'decibel_milliwatt',
      name: 'wifi_strength_iqm',
      data: [null, -40.75, -40.48, -40.46, -40.41, -43.6, -45.61, -47.3, -47, -47.34],
    },
    {
      feature: 'adf_148',
      unit: 'decibel_milliwatt',
      name: 'wifi_strength_std',
      data: [null, 2.28, 0.84, 0.76, 1.61, 3.23, 3.2, 0.7, 0.65, 0.68],
    },
    {
      feature: 'adf_149',
      unit: 'number',
      name: 'dhw_pump_number_of_events',
      data: [null, 7, 7, 7, 6, 6, 6, 8, 6, 7],
    },
    {
      feature: 'adf_150',
      unit: 'minute',
      name: 'dhw_pump_duration_mean',
      data: [null, 8.93, 14.29, 9, 9, 8.75, 11.75, 8.19, 12.17, 11.64],
    },
    {
      feature: 'adf_151',
      unit: 'minute',
      name: 'dhw_pump_duration_total',
      data: [null, 62.5, 100, 63, 54, 52.5, 70.5, 65.5, 73, 81.5],
    },
    {
      feature: 'adf_152',
      unit: 'number',
      name: 'dhw_circulation_pump_number_of_events',
      data: [null, 4, 4, 4, 3, 3, 3, 4, 4, 4],
    },
    {
      feature: 'adf_153',
      unit: 'minute',
      name: 'dhw_circulation_pump_duration_mean',
      data: [null, 112.63, 112.63, 182.88, 140, 140.17, 139.67, 181, 112.5, 112.38],
    },
    {
      feature: 'adf_154',
      unit: 'minute',
      name: 'dhw_circulation_pump_duration_total',
      data: [null, 450.5, 450.5, 731.5, 420, 420.5, 419, 724, 450, 449.5],
    },
    {
      feature: 'adf_182',
      unit: 'degree_celsius',
      name: 'target_supply_-10_hc0',
      data: [null, 54.68, 54.68, 54.68, 54.68, 54.68, 54.68, 54.68, 54.68, 54.68],
    },
    {
      feature: 'adf_183',
      unit: 'degree_celsius',
      name: 'target_supply_0_hc0',
      data: [null, 46.16, 46.16, 46.16, 46.16, 46.16, 46.16, 46.16, 46.16, 46.16],
    },
    {
      feature: 'adf_184',
      unit: 'degree_celsius',
      name: 'target_supply_10_hc0',
      data: [null, 36.57, 36.57, 36.57, 36.57, 36.57, 36.57, 36.57, 36.57, 36.57],
    },
    {
      feature: 'adf_185',
      unit: 'degree_celsius',
      name: 'target_supply_-10_for_22_hc0',
      data: [null, 56.53, 56.53, 56.53, 56.53, 56.53, 56.53, 56.53, 56.53, 56.53],
    },
    {
      feature: 'adf_186',
      unit: 'degree_celsius',
      name: 'target_supply_0_for_22_hc0',
      data: [null, 48.04, 48.04, 48.04, 48.04, 48.04, 48.04, 48.04, 48.04, 48.04],
    },
    {
      feature: 'adf_187',
      unit: 'degree_celsius',
      name: 'target_supply_10_for_22_hc0',
      data: [null, 38.62, 38.62, 38.62, 38.62, 38.62, 38.62, 38.62, 38.62, 38.62],
    },
    {
      feature: 'adf_188',
      unit: 'degree_celsius',
      name: 'target_supply_-10_hc1',
      data: [null, 40.58, 40.58, 40.58, 40.58, 40.58, 40.58, 40.58, 40.58, 40.58],
    },
    {
      feature: 'adf_189',
      unit: 'degree_celsius',
      name: 'target_supply_0_hc1',
      data: [null, 34.59, 34.59, 34.59, 34.59, 34.59, 34.59, 34.59, 34.59, 34.59],
    },
    {
      feature: 'adf_190',
      unit: 'degree_celsius',
      name: 'target_supply_10_hc1',
      data: [null, 27.75, 27.75, 27.75, 27.75, 27.75, 27.75, 27.75, 27.75, 27.75],
    },
    {
      feature: 'adf_191',
      unit: 'degree_celsius',
      name: 'target_supply_-10_for_22_hc1',
      data: [null, 43.77, 43.77, 43.77, 43.77, 43.77, 43.77, 43.77, 43.77, 43.77],
    },
    {
      feature: 'adf_192',
      unit: 'degree_celsius',
      name: 'target_supply_0_for_22_hc1',
      data: [null, 37.83, 37.83, 37.83, 37.83, 37.83, 37.83, 37.83, 37.83, 37.83],
    },
    {
      feature: 'adf_193',
      unit: 'degree_celsius',
      name: 'target_supply_10_for_22_hc1',
      data: [null, 31.23, 31.23, 31.23, 31.23, 31.23, 31.23, 31.23, 31.23, 31.23],
    },
    {
      feature: 'adf_2',
      unit: 'degree_celcius',
      name: 'minimum_outside_temperature',
      data: [null, -2.4, -4.4, -4.2, -6.2, -5.2, -8.2, -10.2, -11.2, -11.2],
    },
    {
      feature: 'adf_206',
      unit: 'boolean',
      name: 'config_vacation',
      data: [null, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    {
      feature: 'adf_207',
      unit: 'boolean',
      name: 'config_heating_active',
      data: [null, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    },
    {
      feature: 'adf_242',
      unit: 'minute',
      name: 'config_heating_schedule_duration_hc0',
      data: [null, 960, 960, 600, 600, 600, 600, 600, 960, 960],
    },
    {
      feature: 'adf_243',
      unit: 'minute',
      name: 'config_heating_schedule_duration_hc1',
      data: [null, 960, 960, 660, 660, 660, 660, 660, 960, 960],
    },
    {
      feature: 'adf_25',
      unit: 'number',
      name: 'dhw_gas_charging_events',
      data: [null, 7, 7, 7, 6, 6, 6, 8, 6, 7],
    },
    {
      feature: 'adf_26',
      unit: 'minute',
      name: 'dhw_gas_charging_duration',
      data: [null, 9.93, 15.57, 9.64, 9.25, 8.75, 13.58, 8.69, 12.92, 12.93],
    },
    {
      feature: 'adf_27',
      unit: 'percentage_minute',
      name: 'dhw_gas_modulation_integral',
      data: [null, 614.07, 1139.21, 627.57, 591, 560.08, 884.83, 546.88, 890.17, 892.29],
    },
    {
      feature: 'adf_28',
      unit: 'kelvin',
      name: 'dhw_gas_charging',
      data: [null, 6.04, 11.66, 6.54, 5.82, 6.28, 9.2, 5.61, 9.33, 9.47],
    },
    {
      feature: 'adf_29',
      unit: 'kelvin_per_minute',
      name: 'dhw_gas_charging_rate',
      data: [null, 0.62, 0.7, 0.69, 0.64, 0.72, 0.62, 0.65, 0.69, 0.69],
    },
    {
      feature: 'adf_3',
      unit: 'degree_celcius',
      name: 'maximum_outside_temperature',
      data: [null, 0.6, -2.4, -2.4, -3.2, -0.2, -1.2, -1.2, -1.2, -1.2],
    },
    {
      feature: 'adf_30',
      unit: 'percentage_minute_per_kelvin',
      name: 'dhw_gas_charging_efficiency',
      data: [null, 101.14, 97.16, 96.2, 101.33, 88.6, 97.24, 97.46, 91.71, 95.39],
    },
    {
      feature: 'adf_31',
      unit: 'number',
      name: 'dhw_gas_starts',
      data: [null, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    },
    {
      feature: 'adf_32',
      unit: 'number',
      name: 'dhw_gas_usage_events',
      data: [null, 5, 5, 3, 2, 1, 2, 2, 2, 4],
    },
    {
      feature: 'adf_33',
      unit: 'minute',
      name: 'dhw_gas_usage_duration',
      data: [null, 1.3, 3.3, 0.67, 0.5, 0.5, 3.25, 0.5, 4, 2.88],
    },
    {
      feature: 'adf_34',
      unit: 'number',
      name: 'dhw_gas_cooling_events',
      data: [null, 11, 10, 9, 9, 9, 8, 9, 9, 12],
    },
    {
      feature: 'adf_35',
      unit: 'minute',
      name: 'dhw_gas_cooling_duration',
      data: [null, 121.55, 130.35, 150.44, 150.39, 144.5, 167.38, 150.67, 148.17, 109.83],
    },
    {
      feature: 'adf_36',
      unit: 'kelvin_per_minute',
      name: 'dhw_gas_cooling_rate',
      data: [null, -0.03, -0.04, -0.03, -0.04, -0.03, -0.04, -0.03, -0.04, -0.03],
    },
    {
      feature: 'adf_37',
      unit: 'number',
      name: 'main_gas_heating_events',
      data: [null, 29, 47, 42, 13, 21, 14, 20, 13, 12],
    },
    {
      feature: 'adf_38',
      unit: 'minute',
      name: 'main_gas_heating_event_duration',
      data: [null, 5, 4, 4, 6, 5.5, 5.5, 5, 6, 5],
    },
    {
      feature: 'adf_39',
      unit: 'kelvin',
      name: 'main_gas_temperature_difference',
      data: [null, 12.7, 11, 12.35, 3.4, 8.4, 2, 2.75, 3.5, 2.35],
    },
    {
      feature: 'adf_4',
      unit: 'degree_celcius',
      name: 'average_outside_temperature',
      data: [null, -0.54, -3.6, -3.1, -4.18, -2.2, -4.75, -5.75, -6.76, -5.91],
    },
    {
      feature: 'adf_43',
      unit: 'degree_celsius',
      name: 'main_temperature_min',
      data: [null, 28, 28, 31, 30, 31, 32.5, 32.5, 39.6, 31],
    },
    {
      feature: 'adf_44',
      unit: 'degree_celsius',
      name: 'main_temperature_max',
      data: [null, 77.5, 78, 77.5, 77, 77.5, 77, 77, 77, 77.5],
    },
    {
      feature: 'adf_45',
      unit: 'degree_celsius',
      name: 'main_temperature_mean',
      data: [null, 44.38, 46.95, 46.33, 46.37, 45.73, 46.79, 48.18, 50.33, 50.33],
    },
    {
      feature: 'adf_46',
      unit: 'kelvin',
      name: 'main_temperature_std',
      data: [null, 7.85, 9.55, 8.4, 6.71, 6.94, 6.98, 6.77, 5.98, 6.53],
    },
    {
      feature: 'adf_47',
      unit: 'boolean',
      name: 'config_dhw_active',
      data: [null, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    },
    {
      feature: 'adf_49',
      unit: 'degree_celsius',
      name: 'main_temperature_heating',
      data: [null, 45.68, 48.47, 46.78, 44.35, 43.79, 44.75, 46.48, 48.81, 49.38],
    },
    {
      feature: 'adf_5',
      unit: 'kelvin',
      name: 'difference_outside_temperature',
      data: [null, 3, 2, 1.8, 3, 5, 7, 9, 10, 10],
    },
    {
      feature: 'adf_50',
      unit: 'degree_celsius',
      name: 'main_temperature_heating_min',
      data: [null, 31.6, 34, 34, 32, 33, 33.5, 34.3, 44, 33],
    },
    {
      feature: 'adf_51',
      unit: 'degree_celsius',
      name: 'main_temperature_heating_max',
      data: [null, 72, 75, 77.5, 69.5, 72.5, 72, 71, 72.5, 70.5],
    },
    {
      feature: 'adf_52',
      unit: 'percent',
      name: 'modulation_heating',
      data: [null, 35.6, 49.16, 42.58, 32.55, 32.61, 32.42, 35.45, 36.93, 35.53],
    },
    {
      feature: 'adf_53',
      unit: 'percent',
      name: 'modulation_heating_min',
      data: [null, 11, 12, 11, 11, 11, 11, 11, 11, 11],
    },
    {
      feature: 'adf_54',
      unit: 'percent',
      name: 'modulation_heating_max',
      data: [null, 96, 99, 78, 89, 90, 94, 92, 94, 100],
    },
    {
      feature: 'adf_55',
      unit: 'degree_celsius',
      name: 'flue_temperature_heating',
      data: [null, 39.82, 41.93, 40.6, 39.83, 39.03, 39.45, 41.54, 43.34, 43.39],
    },
    {
      feature: 'adf_56',
      unit: 'degree_celsius',
      name: 'flue_temperature_heating_min',
      data: [null, 30, 30, 31, 31.3, 31.6, 33.5, 33.5, 38.5, 33],
    },
    {
      feature: 'adf_57',
      unit: 'degree_celsius',
      name: 'flue_temperature_heating_max',
      data: [null, 75, 75.5, 74.5, 74.5, 74.5, 75, 75, 76, 75],
    },
    {
      feature: 'adf_58',
      unit: 'degree_celsius',
      name: 'main_temperature_dhw',
      data: [null, 75.3, 72.65, 75.61, 75.71, 75.62, 72.55, 75.93, 72.6, 72.71],
    },
    {
      feature: 'adf_59',
      unit: 'degree_celsius',
      name: 'main_temperature_dhw_min',
      data: [null, 49.5, 43.5, 52.5, 40, 53.6, 53, 50, 49, 50],
    },
    {
      feature: 'adf_6',
      unit: 'number',
      name: 'cumulative_burner_starts',
      data: [null, 20063, 20108, 20142, 20144, 20153, 20155, 20159, 20160, 20161],
    },
    {
      feature: 'adf_60',
      unit: 'degree_celsius',
      name: 'main_temperature_dhw_max',
      data: [null, 77.5, 78, 77.5, 77, 77.5, 77, 77, 77, 77.5],
    },
    {
      feature: 'adf_61',
      unit: 'percent',
      name: 'modulation_dhw',
      data: [null, 87.21, 94.09, 82.7, 82, 80.38, 91.7, 81.4, 89.59, 91.59],
    },
    {
      feature: 'adf_62',
      unit: 'percent',
      name: 'modulation_dhw_min',
      data: [null, 54, 33, 54, 56, 22, 56, 54, 22, 53],
    },
    {
      feature: 'adf_63',
      unit: 'percent',
      name: 'modulation_dhw_max',
      data: [null, 99, 100, 100, 99, 99, 100, 99, 100, 100],
    },
    {
      feature: 'adf_64',
      unit: 'degree_celsius',
      name: 'flue_temperature_dhw',
      data: [null, 64.74, 64.34, 67.67, 67.21, 68.45, 66.19, 69.81, 66.56, 65.93],
    },
    {
      feature: 'adf_65',
      unit: 'degree_celsius',
      name: 'flue_temperature_dhw_min',
      data: [null, 48.6, 40.5, 50, 46.6, 51, 51.3, 52, 47, 49.5],
    },
    {
      feature: 'adf_66',
      unit: 'degree_celsius',
      name: 'flue_temperature_dhw_max',
      data: [null, 75, 75.5, 74.5, 74.5, 74.5, 75, 75, 76, 75],
    },
    {
      feature: 'adf_67',
      unit: 'degree_celsius',
      name: 'flue_temperature_min',
      data: [null, 30, 30, 31, 31.3, 31.6, 33.5, 33.5, 38.5, 33],
    },
    {
      feature: 'adf_68',
      unit: 'degree_celsius',
      name: 'flue_temperature_max',
      data: [null, 75, 75.5, 74.5, 74.5, 74.5, 75, 75, 76, 75],
    },
    {
      feature: 'adf_69',
      unit: 'degree_celsius',
      name: 'flue_temperature_mean',
      data: [null, 39.78, 42.04, 41.39, 41.37, 40.73, 41.75, 42.94, 44.49, 44.65],
    },
    {
      feature: 'adf_7',
      unit: 'hour',
      name: 'cumulative_burner_hours',
      data: [null, 7775, 7793.7, 7813.2, 7837, 7860.6, 7884.5, 7908.1, 7932.1, 7956],
    },
    {
      feature: 'adf_70',
      unit: 'kelvin',
      name: 'flue_temperature_std',
      data: [null, 6.63, 7.88, 6.9, 5.97, 6.19, 6.52, 6.39, 6.04, 6.29],
    },
    {
      feature: 'adf_8',
      unit: 'number',
      name: 'burner_starts',
      data: [null, 21, 45, 34, 2, 9, 2, 4, 1, 1],
    },
    {
      feature: 'adf_9',
      unit: 'hour',
      name: 'burner_hours',
      data: [null, 21, 18.7, 19.5, 23.8, 23.6, 23.9, 23.6, 24, 23.9],
    },
  ],
};

export const overviewMock = [
  {
    boiler_id: '7570782903267119',
    boiler_material_number: 7570782,
    diagnosis_date: '2021-02-17T00:00:00Z',
    diagnosis_id: 'add_10',
    diagnosis_name: 'dhw_efficiency_anomaly',
    diagnosis_group: 'dhw_heat_exchanger',
    diagnosis_value: {
      diagnosis: 'dhw efficiency has not worsened',
      timeframe: 395,
      anomaly: 0,
      median_begin: '90.241546630859375',
      median_end: '96.3443832397461',
      efficiency_timeframe: 30,
      efficiency_limit: 2,
      days: 239,
    },
    diagnosis_anomaly: 0,
    diagnosis_priority: 'information',
    diagnosis_text: 'dhw_efficiency_has_not_worsened',
    metrics: { median_begin: '90.2', median_end: '96.3' },
    actions: ['tbd'],
    relevant_adf: ['adf_30'],
  },
  {
    boiler_id: '7570782903267119',
    boiler_material_number: 7570782,
    diagnosis_date: '2021-02-17T00:00:00Z',
    diagnosis_id: 'add_5',
    diagnosis_name: 'remaining_useful_life_of_electrodes',
    diagnosis_group: 'electrodes',
    diagnosis_value: {
      diagnosis: 'high risk of failure',
      timeframe: 365,
      daily_running_hours_rate: '11.560606002807615',
      remaining_running_hours: 1976.5,
      estimated_failure_date: '2021-08-06T00:00:00.0000000Z',
      remaining_useful_life: 170,
      current_running_hours: 8023.5,
      max_electrodes_life: 10000,
      warn_limit: 180,
    },
    diagnosis_anomaly: 1,
    diagnosis_priority: 'warning',
    diagnosis_text: 'high_risk_of_failure',
    metrics: { estimated_failure_date: '2021-08-06' },
    actions: ['tbd'],
    relevant_adf: [],
  },
];

export const summaryMock = {
  boiler_id: '7570782903267119',
  boiler_material_number: 7570782,
  recommendation_date: '2021-02-17T00:00:00Z',
  recommendation_id: 'adr_1',
  recommendation_name: 'anomaly_score',
  recommendation_group: 'anomaly_detection',
  recommendation_value: {
    group_scores: {
      outside_temperature: 0,
      main_heat_exchanger: 0,
      dhw_heat_exchanger: 0,
      general_activity: 0,
      burner_clocking: 0,
      data_quality: 0,
      electrodes: 2,
    },
    config: {
      outside_temperature: {
        return_by_missing: 0,
        diagnose_period: 1,
        anomaly_weight: 1,
      },
      main_heat_exchanger: {
        return_by_missing: 0,
        diagnose_period: 1,
        anomaly_weight: 1,
      },
      dhw_heat_exchanger: {
        return_by_missing: 0,
        diagnose_period: 1,
        anomaly_weight: 1,
      },
      general_activity: {
        return_by_missing: 0,
        diagnose_period: 3,
        anomaly_weight: 1,
      },
      burner_clocking: {
        return_by_missing: 0,
        diagnose_period: 3,
        anomaly_weight: 1,
      },
      data_quality: {
        return_by_missing: 4,
        diagnose_period: 4,
        anomaly_weight: 1,
      },
      compressor_clocking: {
        return_by_missing: 0,
        diagnose_period: 3,
        anomaly_weight: 1,
      },
      electrodes: {
        return_by_missing: 0,
        diagnose_period: 1,
        anomaly_weight: 1,
      },
      heating_rod: {
        return_by_missing: 0,
        diagnose_period: 1,
        anomaly_weight: 1,
      },
      fuel_cell: {
        return_by_missing: 0,
        diagnose_period: 3,
        anomaly_weight: 1,
      },
      leakage: {
        return_by_missing: 0,
        diagnose_period: 2,
        anomaly_weight: 1,
      },
      solar: {
        return_by_missing: 0,
        diagnose_period: 1,
        anomaly_weight: 1,
      },
    },
  },
  recommendation_score: 2,
};
